<template>
  <modal
    class="winner-evalution-modal"
    name="winner-evalution-modal"
    @closed="$emit('updateComparisonData')"
    @before-open="handleBeforeOpen"
    transition="fade"
    :adaptive="true"
    :scrollable="true"
    :reset="true"
    width="98%"
    height="80%"
  >
    <div id="modal-header" style="background-color:#006BE6">
      <div class="w-75 d-flex align-items-center text-white">
        <p class="mb-0">Մասնակիցներրի գնահատում</p>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 25%"
              @click="$modal.hide('winner-evalution-modal')" aria-label="Close">
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z" fill="#ffffff"/>
        </svg>
      </button>
    </div>
    <div id="modal-body">
      <template v-if="participants.length === 0">
        <div class="h-100 d-flex align-items-center justify-content-center">
          <div class="text-center p-3">
            <h5 class="font-size-24 m-3">Գնահատման ենթակա մասնակիցներ չկան</h5>
          </div>
        </div>
      </template>
      <div v-else class="d-flex">
        <div class="col-md-12 p-0">
          <div v-if="!isMobile && hasBrandFeature(BRAND_FEATURES.AMERIA_EVALUATION_EXTRAS)" class="d-flex align-items-center justify-content-between mb-3">
            <div class="btn-group" role="group">
              <button
                type="button"
                class="btn btn-sm"
                :class="viewMode === 'participant' ? 'btn-primary' : 'btn-outline-primary'"
                @click="viewMode = 'participant'"
              >Ըստ մասնակիցների</button>
              <button
                type="button"
                class="btn btn-sm"
                :class="viewMode === 'lot' ? 'btn-primary' : 'btn-outline-primary'"
                @click="viewMode = 'lot'"
              >Ըստ չափաբաժինների</button>
            </div>
            <button type="button" class="btn btn-sm btn-success" @click="exportEvaluationExcel" :disabled="isExporting">
              <i class="mdi mdi-microsoft-excel mr-1"></i> Excel-ով արտահանել
            </button>
          </div>
          <template v-if="isMobile">
            <table class="table table-borderless VueTables__table table table-striped table-border-radius">
              <tbody>
                <div id="accordion">
                  <div class="row-mobile" v-for="(participant, participantIndex) in participants" :key="participant.id">
                    <div class="mobile-card m-0">
                        <div class="mobile-table-header" :id="`heading-${participantIndex}`">
                            <div data-toggle="collapse" class="collapsed" :data-target="`#collapse-${participantIndex}`" aria-expanded="false" :aria-controls="`#collapse-${participantIndex}`">
                                <div class="row m-0 p-0 justify-content-between">
                                    <div class="col-10 p-0">
                                        <div class="row m-0 p-0 card-header-text">
                                            <div class="col-auto little-col">
                                                {{ participantIndex + 1 }}
                                            </div>
                                            <div class="col p-0 d-flex align-items-center">
                                                {{ participant.name }}
                                                <span v-if="participant.verification_status === 'verified'" class="text-success ml-1" title="Ստուգված">✓</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-2 p-0 d-flex align-items-center justify-content-end">
                                        <svg width="14" height="8" viewBox="0 0 14 8">
                                            <path d="M8.40545 6.48276L13.2227 1.51724L11.7507 -6.43398e-08L6.93353 4.96552L2.25014 -4.79624e-07L0.778211 1.51724L5.4616 6.48276L6.93353 8L8.40545 6.48276Z" fill="#006BE6"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div :id="`collapse-${participantIndex}`" class="collapse" :aria-labelledby="`heading-${participantIndex}`">
                          <div class="card-body mobile-table-row-body">
                            <div class="mobile-table-row">
                              <div v-if="hasBrandFeature(BRAND_FEATURES.CUSTOM_COMMERCIAL_TERMS)" class="mb-2">
                                <button
                                  type="button"
                                  @click="openCommercialTermsModal(participant)"
                                  class="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                                >
                                  <span>Առևտրային պայմաններ</span>
                                </button>
                              </div>
                              <label class="cell-name mr-1">Կցված փաստաթղթեր`</label>
                              <div class="cell-name" v-if="participant.additional_file">
                                <a
                                  :href="participant.additional_file"
                                  target="_blank"
                                  download
                                  class="btn btn-light "
                                >
                                  <svg class="mr-2" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.52148 12.7617C3.52148 13.357 3.99767 13.8332 4.59291 13.8332H12.8667C13.462 13.8332 13.9381 13.357 13.9381 12.7617V3.23793C13.9381 2.64269 13.462 2.1665 12.8667 2.1665H4.59291C3.99767 2.1665 3.52148 2.64269 3.52148 3.23793V12.7617ZM12.9858 12.8808H4.47387V3.11888H12.9858V12.8808ZM6.08102 4.72613H11.4382V5.67851H6.08102V4.72613ZM11.4382 10.3212H6.08102V11.2736H11.4382V10.3212ZM6.08102 7.52365H11.4382V8.47603H6.08102V7.52365Z" fill="#006BE6"/>
                                  </svg>
                                  <span>Բեռնել</span>
                                </a>
                              </div>
                              <div class="cell-name mt-1" v-if="getParticipantOfferExcel(participant)">
                                <a
                                  :href="getParticipantOfferExcel(participant)"
                                  target="_blank"
                                  download
                                  class="btn btn-light d-inline-flex align-items-center text-primary"
                                >
                                  <i class="far fa-file-excel mr-2 text-success font-18"></i>
                                  <span>Excel առաջարկ</span>
                                </a>
                              </div>
                              <div :key="`${participantIndex} + ${lot.id}`" v-for="(lot, lotIndex) in participant.lots">
                                <label class="cell-name">Չ/Հ</label>`
                                <span class="ml-2">{{lot.row.view_id}}</span>
                                <label class="cell-name d-block">Գնման առարկա`</label>
                                <p>{{lot.cpv.name}}</p>
                                <label class="cell-name">Ներկայացված գին`</label>
                                <p class="mb-1">{{lot.cost}}</p>
                                <div v-if="me?.organisation?.[0]?.has_model_logging" class="mb-2">
                                  <button
                                    type="button"
                                    @click="openActivityLogModal(lot)"
                                    class="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                                    style="font-size: 11px; padding: 2px 6px;"
                                  >
                                    <svg class="mr-1" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M1.75 8a6.25 6.25 0 1 0 1.83-4.42L1.75 5.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                      <polyline points="1.75 1.75 1.75 5.5 5.5 5.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                      <polyline points="8 4.5 8 8 10.5 9.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <span>Պատմություն</span>
                                  </button>
                                </div>
                                <label class="cell-name">Ներկայացված տեխնիկական բնութագիր`</label>
                                <p>{{lot.specification}}</p>

                                <div>
                                  <template v-if="winnerByLots">
                                    <div :style="lotIndex === 0 ? 'border: none' : ''">
                                      <template v-if="organizeType !== 3">
                                        <div class="form-check d-inline-block">
                                          <label>
                                          <input
                                            v-model="lot.is_satisfactory"
                                            :value="1"
                                            class="form-check-input"
                                            type="radio"
                                            :name="`is_satisfactory-${lot.id}-${participant.id}`"
                                            :id="`is_satisfactory-${lot.id}-${participant.id}`"
                                          >
                                          <label class="form-check-label" :for="`is_satisfactory-${lot.id}-${participant.id}`">
                                            Բավարար
                                          </label>
                                          </label>
                                        </div>
                                        <div class="form-check d-inline-block ml-2">
                                          <label>
                                          <input
                                            v-model="lot.is_satisfactory"
                                            :value="0"
                                            class="form-check-input"
                                            type="radio"
                                            :name="`is_satisfactory-false-${lot.id}-${participant.id}`"
                                            :id="`is_satisfactory-false-${lot.id}-${participant.id}`"
                                          >
                                          <label class="form-check-label" :for="`is_satisfactory-false-${lot.id}-${participant.id}`">
                                            Անբավարար
                                          </label>
                                          </label>
                                        </div>
                                        <div v-if="!lot.is_satisfactory" class="form-group text-left my-2">
                                          <label :for="`reason-${lot.id}-${participant.id}`">Հիմնավորում</label>
                                          <textarea v-model="lot.rejection_reason" class="form-control br-8" :id="`reason-${lot.id}-${participant.id}`" rows="3"></textarea>
                                        </div>
                                      </template>
                                      <template v-else>
                                        <label class="cell-name mr-2">Հաղթող՝</label>
                                        <input
                                          v-model="winnerRows[lot.organize_row_id]"
                                          :name="`winner-${lot.organize_row_id}`"
                                          :id="`winner-${lot.organize_row_id}`"
                                          :value="participant.id"
                                          type="radio"
                                        >
                                      </template>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <div v-if="lotIndex === 0" :rowspan="participant.lots.length + 1">
                                      <template v-if="organizeType !== 3">
                                        <div class="form-check d-inline-block">
                                          <input
                                            v-model="lot.is_satisfactory"
                                            :value="1"
                                            class="form-check-input"
                                            type="radio"
                                            :name="`is_satisfactory-${lot.id}-${participant.id}`"
                                            :id="`is_satisfactory-${lot.id}-${participant.id}`"
                                          >
                                          <label class="form-check-label" :for="`is_satisfactory-${lot.id}-${participant.id}`">
                                            Բավարար
                                          </label>
                                        </div>
                                        <div class="form-check d-inline-block ml-2">
                                          <input
                                            v-model="lot.is_satisfactory"
                                            :value="0"
                                            class="form-check-input"
                                            type="radio"
                                            :name="`is_satisfactory-false-${lot.id}-${participant.id}`"
                                            :id="`is_satisfactory-false-${lot.id}-${participant.id}`"
                                          >
                                          <label class="form-check-label" :for="`is_satisfactory-false-${lot.id}-${participant.id}`">
                                            Անբավարար
                                          </label>
                                        </div>
                                        <div v-if="!lot.is_satisfactory" class="form-group text-left my-2">
                                          <label :for="`reason-${lot.id}-${participant.id}`">Հիմնավորում</label>
                                          <textarea v-model="lot.rejection_reason" class="form-control br-8" :id="`reason-${lot.id}-${participant.id}`" rows="3"></textarea>
                                        </div>
                                      </template>
                                      <template v-else>
                                        <label class="cell-name mr-2">Հաղթող՝</label>
                                        <input v-model="winnerId" type="radio" id="winner" name="winner" :value="participant.id">
                                      </template>
                                    </div>
                                  </template>
                                </div>
                                <hr v-if="winnerByLots && lotIndex !== participant.lots.length-1"/>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </tbody>
            </table>
          </template>
          <template v-else-if="viewMode === 'lot'">
            <table class="evalution-table table table-borderless table table-striped table-border-radius" style="border-collapse: collapse; border-spacing: 0; width: 100% !important;;">
              <thead>
                <tr>
                  <th style="width: 120px;">Հ/Հ</th>
                  <th>Մասնակից</th>
                  <template v-if="hasBrandFeature(BRAND_FEATURES.DETAILED_UNIT_PRICES)">
                    <th>Միավոր գին Առանց ԱԱՀ</th>
                    <th>Միավոր գին ԱԱՀ</th>
                    <th>Ընդհանուր գին</th>
                  </template>
                  <template v-else>
                    <th>Ներկայացված գին</th>
                  </template>
                  <th>Ներկայացված տեխնիկական բնութագիր</th>
                  <th>Կցված փաստաթղթեր</th>
                  <th>
                    <template v-if="organizeType !== 3">Գնահատում</template>
                    <template v-else>Հաղթող</template>
                  </th>
                </tr>
              </thead>
              <tbody v-if="lotsGrouped.length" id="comparison-table-by-lot">
                <template v-for="(lotGroup, lotGroupIndex) in lotsGrouped">
                  <tr :key="`lot-header-${lotGroup.organize_row_id}`" style="background:#f5f7fa;">
                    <td colspan="7" style="font-weight: 600;">
                      {{ lotGroupIndex + 1 }}. Չ/Հ {{ lotGroup.view_id }} — {{ lotGroup.cpv ? lotGroup.cpv.name : '' }}
                    </td>
                  </tr>
                  <tr
                    v-for="(item, itemIndex) in lotGroup.items"
                    :key="`lot-${lotGroup.organize_row_id}-p-${item.participant.id}`"
                  >
                    <td>{{ itemIndex + 1 }}</td>
                    <td>
                      {{ item.participant.name }}
                      <span v-if="hasBrandFeature(BRAND_FEATURES.TIN_DISPLAY)"><br>ՀՎՀՀ՝ {{ item.participant.tin }}</span>
                    </td>
                    <template v-if="hasBrandFeature(BRAND_FEATURES.DETAILED_UNIT_PRICES)">
                      <td>{{ formatPrice(item.lot.value / (item.lot.row?.procurement_plan?.details[0]?.count || 1)) }}</td>
                      <td>{{ formatPrice(item.lot.vat / (item.lot.row?.procurement_plan?.details[0]?.count || 1)) }}</td>
                      <td>{{ formatPrice(item.lot.cost) }}</td>
                    </template>
                    <template v-else>
                      <td>{{ item.lot.cost }}</td>
                    </template>
                    <td>{{ item.lot.specification }}</td>
                    <td>
                      <div v-if="item.participant.additional_file" class="my-1">
                        <a
                          :href="item.participant.additional_file"
                          target="_blank"
                          download
                          class="btn btn-light btn-sm"
                        >Բեռնել</a>
                      </div>
                      <div v-if="getParticipantOfferExcel(item.participant)" class="my-1">
                        <a
                          :href="getParticipantOfferExcel(item.participant)"
                          target="_blank"
                          download
                          class="btn btn-light btn-sm d-inline-flex align-items-center text-primary"
                        >
                          <i class="far fa-file-excel mr-2 text-success font-18"></i>
                          <span>Excel առաջարկ</span>
                        </a>
                      </div>
                    </td>
                    <td>
                      <template v-if="winnerByLots">
                        <template v-if="organizeType !== 3">
                          <div class="form-check d-inline-block">
                            <input
                              v-model="item.lot.is_satisfactory"
                              :value="1"
                              class="form-check-input"
                              type="radio"
                              :name="`is_satisfactory-lot-${item.lot.id}-${item.participant.id}`"
                            >
                            <label class="form-check-label">Բավարար</label>
                          </div>
                          <div class="form-check d-inline-block ml-2">
                            <input
                              v-model="item.lot.is_satisfactory"
                              :value="0"
                              class="form-check-input"
                              type="radio"
                              :name="`is_satisfactory-lot-false-${item.lot.id}-${item.participant.id}`"
                            >
                            <label class="form-check-label">Անբավարար</label>
                          </div>
                          <div v-if="!item.lot.is_satisfactory" class="form-group text-left my-2">
                            <textarea v-model="item.lot.rejection_reason" class="form-control br-8" rows="2"></textarea>
                          </div>
                        </template>
                        <template v-else>
                          <input
                            :name="`winner-lot-${item.lot.organize_row_id}`"
                            :value="item.participant.id"
                            type="radio"
                            :checked="winnerRows[item.lot.organize_row_id] === item.participant.id"
                            @click="toggleWinner(item.participant.id, item.lot.organize_row_id)"
                          >
                        </template>
                      </template>
                      <template v-else>
                        <template v-if="organizeType !== 3">
                          <div class="form-check d-inline-block">
                            <input
                              v-model="item.lot.is_satisfactory"
                              :value="1"
                              class="form-check-input"
                              type="radio"
                              :name="`is_satisfactory-lot-${item.lot.id}-${item.participant.id}`"
                            >
                            <label class="form-check-label">Բավարար</label>
                          </div>
                          <div class="form-check d-inline-block ml-2">
                            <input
                              v-model="item.lot.is_satisfactory"
                              :value="0"
                              class="form-check-input"
                              type="radio"
                              :name="`is_satisfactory-lot-false-${item.lot.id}-${item.participant.id}`"
                            >
                            <label class="form-check-label">Անբավարար</label>
                          </div>
                          <div v-if="!item.lot.is_satisfactory" class="form-group text-left my-2">
                            <textarea v-model="item.lot.rejection_reason" class="form-control br-8" rows="2"></textarea>
                          </div>
                        </template>
                        <template v-else>
                          <input
                            type="radio"
                            name="winner"
                            :value="item.participant.id"
                            :checked="winnerId === item.participant.id"
                            @click="toggleWinner(item.participant.id)"
                          >
                        </template>
                      </template>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </template>
          <template v-else>
            <table class="evalution-table table table-borderless table table-striped table-border-radius" style="border-collapse: collapse; border-spacing: 0; width: 100% !important;;">
              <thead>
                <tr>
                  <th style="width: 120px;">Հ/Հ</th>
                  <th>Անվանում</th>
                  <th>Գնման առարկա</th>
                  <th v-if="hasBrandFeature(BRAND_FEATURES.PRE_ESTIMATED_PRICE)">նախահաշվային գին</th>


                  <template v-if="hasBrandFeature(BRAND_FEATURES.DETAILED_UNIT_PRICES)">
                    <th>Միավոր գին Առանց ԱԱՀ</th>
                    <th>Միավոր գին ԱԱՀ</th>
                    <th>Միավոր գին Ընդհանուր գին</th>

                    <th>Առանց ԱԱՀ</th>
                    <th>ԱԱՀ</th>
                    <th>Ընդհանուր գին</th>
                  </template>
                  <template v-else>
                    <th>Ներկայացված գին</th>
                  </template>

                  <th>Ներկայացված տեխնիկական բնութագիր</th>
                  <th>Կցված փաստաթղթեր</th>
                  <th>
                    <template v-if="organizeType !== 3">
                      Գնահատում
                    </template>
                    <template v-else>
                      Հաղթող
                    </template>
                  </th>
                  <th v-if="hasBlacklistEnabled">Սև ցուցակ</th>
                </tr>
              </thead>
              <tbody v-if="participants.length" id="comparison-table">
                <template v-for="(participant, participantIndex) in participants">
                  <tr :key="participant.id">
                    <td :rowspan="participant.lots.length + 1">{{ participantIndex + 1 }}</td>
                    <td :rowspan="participant.lots.length + 1">{{ participant.name }}
                      <span v-if="hasBrandFeature(BRAND_FEATURES.TIN_DISPLAY)"><br>ՀՎՀՀ՝ {{ participant.tin }}</span>
                      <div v-if="participant.verification_status === 'verified'" class="small text-success mt-1">
                        <span v-if="participant.is_resident">✓ ՀՀ պետական ռեգիստրով ստուգված<span v-if="participant.verification_checked_at"><br>Վերջին ստուգում՝ {{ formatVerificationDate(participant.verification_checked_at) }}</span></span>
                        <span v-else>✓ Օտարերկրյա կազմակերպություն — ստուգված</span>
                      </div>
                      <div v-if="hasBrandFeature(BRAND_FEATURES.CUSTOM_COMMERCIAL_TERMS)" class="mt-2">
                        <button
                          type="button"
                          @click="openCommercialTermsModal(participant)"
                          class="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                          style="font-size: 12px; padding: 4px 8px;"
                        >
                          <span>Առևտրային պայմաններ</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <template>
                    <tr
                      :key="`${participantIndex} + ${lot.id}`"
                      v-for="(lot, lotIndex) in participant.lots"
                      :style="lotIndex === participant.lots.length - 1 && participantIndex !== participants.length -1 ? 'border-bottom: 1px solid #edeff2;' : ''"
                    >
                      <td :style="lotIndex === 0 ? 'border: none' : ''">{{lot.cpv.name}}</td>
                      <td v-if="hasBrandFeature(BRAND_FEATURES.PRE_ESTIMATED_PRICE)" :style="lotIndex === 0 ? 'border: none' : ''">
                        <template v-if="lot.row?.procurement_plan?.details[0]?.count">{{ lot.row?.procurement_plan?.details[0]?.unit_amount * lot.row?.procurement_plan?.details[0]?.count }} դր.</template>
                        <template v-else>Սահմանված չէ</template>
                      </td>
                      <template v-if="hasBrandFeature(BRAND_FEATURES.DETAILED_UNIT_PRICES)">
                        <td :style="lotIndex === 0 ? 'border: none' : ''">{{ formatPrice(lot.value / (lot.row?.procurement_plan?.details[0]?.count || 1)) }}</td>
                        <td :style="lotIndex === 0 ? 'border: none' : ''">{{ formatPrice(lot.vat / (lot.row?.procurement_plan?.details[0]?.count || 1)) }}</td>
                        <td :style="lotIndex === 0 ? 'border: none' : ''">{{ formatPrice(lot.cost / (lot.row?.procurement_plan?.details[0]?.count || 1)) }}</td>

                        <td :style="lotIndex === 0 ? 'border: none' : ''">{{ formatPrice(lot.value) }}</td>
                        <td :style="lotIndex === 0 ? 'border: none' : ''">{{ formatPrice(lot.vat) }}</td>
                        <td :style="lotIndex === 0 ? 'border: none' : ''">
                          <div>{{ formatPrice(lot.cost) }}</div>
                          <div v-if="me?.organisation?.[0]?.has_model_logging" class="mt-1">
                            <button
                              type="button"
                              @click="openActivityLogModal(lot)"
                              class="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                              style="font-size: 11px; padding: 2px 6px; white-space: nowrap;"
                            >
                              <svg class="mr-1" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.75 8a6.25 6.25 0 1 0 1.83-4.42L1.75 5.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                <polyline points="1.75 1.75 1.75 5.5 5.5 5.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                <polyline points="8 4.5 8 8 10.5 9.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              <span>Պատմություն</span>
                            </button>
                          </div>
                        </td>
                      </template>
                      <template v-else>
                        <td :style="lotIndex === 0 ? 'border: none' : ''">
                          <div>{{lot.cost}}</div>
                          <div v-if="me?.organisation?.[0]?.has_model_logging" class="mt-1">
                            <button
                              type="button"
                              @click="openActivityLogModal(lot)"
                              class="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                              style="font-size: 11px; padding: 2px 6px; white-space: nowrap;"
                            >
                              <svg class="mr-1" width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.75 8a6.25 6.25 0 1 0 1.83-4.42L1.75 5.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                <polyline points="1.75 1.75 1.75 5.5 5.5 5.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                <polyline points="8 4.5 8 8 10.5 9.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              <span>Պատմություն</span>
                            </button>
                          </div>
                        </td>
                      </template>
                      <td :style="lotIndex === 0 ? 'border: none' : ''">{{lot.specification}}</td>
                      <template v-if="winnerByLots">
                        <td v-if="lotIndex === 0" :rowspan="participant.lots.length + 1" style="border: none">
                          <div v-if="participant.additional_file" class="col-auto p-0 justify-content-start my-2">
                            <a
                              :href="participant.additional_file"
                              target="_blank"
                              download
                              class="btn btn-light "
                            >
                              <svg class="mr-2" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.52148 12.7617C3.52148 13.357 3.99767 13.8332 4.59291 13.8332H12.8667C13.462 13.8332 13.9381 13.357 13.9381 12.7617V3.23793C13.9381 2.64269 13.462 2.1665 12.8667 2.1665H4.59291C3.99767 2.1665 3.52148 2.64269 3.52148 3.23793V12.7617ZM12.9858 12.8808H4.47387V3.11888H12.9858V12.8808ZM6.08102 4.72613H11.4382V5.67851H6.08102V4.72613ZM11.4382 10.3212H6.08102V11.2736H11.4382V10.3212ZM6.08102 7.52365H11.4382V8.47603H6.08102V7.52365Z" fill="#006BE6"/>
                              </svg>
                              <span>Բեռնել</span>
                            </a>
                          </div>
                          <div v-if="getParticipantOfferExcel(participant)" class="col-auto p-0 justify-content-start my-2">
                            <a
                              :href="getParticipantOfferExcel(participant)"
                              target="_blank"
                              download
                              class="btn btn-light d-inline-flex align-items-center text-primary"
                            >
                              <i class="far fa-file-excel mr-2 text-success font-18"></i>
                              <span>Excel առաջարկ</span>
                            </a>
                          </div>
                        </td>
                      </template>
                      <template v-else>
                        <td v-if="lotIndex === 0" :rowspan="participant.lots.length + 1">
                          <div v-if="participant.additional_file" class="col-auto p-0 justify-content-start my-2">
                            <a
                              :href="participant.additional_file"
                              target="_blank"
                              download
                              class="btn btn-light "
                            >
                              <svg class="mr-2" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.52148 12.7617C3.52148 13.357 3.99767 13.8332 4.59291 13.8332H12.8667C13.462 13.8332 13.9381 13.357 13.9381 12.7617V3.23793C13.9381 2.64269 13.462 2.1665 12.8667 2.1665H4.59291C3.99767 2.1665 3.52148 2.64269 3.52148 3.23793V12.7617ZM12.9858 12.8808H4.47387V3.11888H12.9858V12.8808ZM6.08102 4.72613H11.4382V5.67851H6.08102V4.72613ZM11.4382 10.3212H6.08102V11.2736H11.4382V10.3212ZM6.08102 7.52365H11.4382V8.47603H6.08102V7.52365Z" fill="#006BE6"/>
                              </svg>
                              <span>Բեռնել</span>
                            </a>
                          </div>
                          <div v-if="getParticipantOfferExcel(participant)" class="col-auto p-0 justify-content-start my-2">
                            <a
                              :href="getParticipantOfferExcel(participant)"
                              target="_blank"
                              download
                              class="btn btn-light d-inline-flex align-items-center text-primary"
                            >
                              <i class="far fa-file-excel mr-2 text-success font-18"></i>
                              <span>Excel առաջարկ</span>
                            </a>
                          </div>
                        </td>
                      </template>
                      <template v-if="winnerByLots">
                        <td :style="lotIndex === 0 ? 'border: none' : ''">
                          <template v-if="organizeType !== 3">
                            <div class="form-check mb-2">
                              <label>
                              <input
                                v-model="lot.is_satisfactory"
                                :value="1"
                                class="form-check-input"
                                type="radio"
                                :name="`is_satisfactory-${lot.id}-${participant.id}`"
                                :id="`is_satisfactory-${lot.id}-${participant.id}`"
                              >
                              <label class="form-check-label" :for="`is_satisfactory-${lot.id}-${participant.id}`">
                                Բավարար
                              </label>
                              </label>
                            </div>
                            <div class="form-check">
                              <label>
                              <input
                                v-model="lot.is_satisfactory"
                                :value="0"
                                class="form-check-input"
                                type="radio"
                                :name="`is_satisfactory-false-${lot.id}-${participant.id}`"
                                :id="`is_satisfactory-false-${lot.id}-${participant.id}`"
                              >
                              <label class="form-check-label" :for="`is_satisfactory-false-${lot.id}-${participant.id}`">
                                Անբավարար
                              </label>
                              </label>
                            </div>
                            <div v-if="!lot.is_satisfactory" class="form-group text-left my-2">
                              <label :for="`reason-${lot.id}-${participant.id}`">Հիմնավորում</label>
                              <textarea v-model="lot.rejection_reason" class="form-control br-8" :id="`reason-${lot.id}-${participant.id}`" rows="3"></textarea>
                            </div>
                          </template>
                          <template v-else>
                            <input
                              :name="`winner-${lot.organize_row_id}`"
                              :id="`winner-${lot.organize_row_id}-${participant.id}`"
                              :value="participant.id"
                              type="radio"
                              :checked="winnerRows[lot.organize_row_id] === participant.id"
                              @click="toggleWinner(participant.id, lot.organize_row_id)"
                            >
                          </template>
                        </td>
                      </template>
                      <template v-else>
                        <td v-if="lotIndex === 0" :rowspan="participant.lots.length + 1">
                          <template v-if="organizeType !== 3">
                            <div class="form-check mb-2">
                              <input
                                v-model="lot.is_satisfactory"
                                :value="1"
                                class="form-check-input"
                                type="radio"
                                :name="`is_satisfactory-${lot.id}-${participant.id}`"
                                :id="`is_satisfactory-${lot.id}-${participant.id}`"
                              >
                              <label class="form-check-label" :for="`is_satisfactory-${lot.id}-${participant.id}`">
                                Բավարար
                              </label>
                            </div>
                            <div class="form-check">
                              <input
                                v-model="lot.is_satisfactory"
                                :value="0"
                                class="form-check-input"
                                type="radio"
                                :name="`is_satisfactory-false-${lot.id}-${participant.id}`"
                                :id="`is_satisfactory-false-${lot.id}-${participant.id}`"
                              >
                              <label class="form-check-label" :for="`is_satisfactory-false-${lot.id}-${participant.id}`">
                                Անբավարար
                              </label>
                            </div>
                            <div v-if="!lot.is_satisfactory" class="form-group text-left my-2">
                              <label :for="`reason-${lot.id}-${participant.id}`">Հիմնավորում</label>
                              <textarea v-model="lot.rejection_reason" class="form-control br-8" :id="`reason-${lot.id}-${participant.id}`" rows="3"></textarea>
                            </div>
                          </template>
                          <template v-else>
                            <input
                              type="radio"
                              name="winner"
                              :id="'winner-' + participant.id"
                              :value="participant.id"
                              :checked="winnerId === participant.id"
                              @click="toggleWinner(participant.id)"
                            >
                          </template>
                        </td>
                      </template>
                      <td v-if="hasBlacklistEnabled && lotIndex === 0" :rowspan="participant.lots.length + 1">
                        <div class="form-check">
                          <label>
                          <input
                            v-model="participant.add_to_blacklist"
                            class="form-check-input"
                            type="checkbox"
                            :id="`add-to-blacklist-${participant.id}`"
                          >
                          <label class="form-check-label" :for="`add-to-blacklist-${participant.id}`">
                            Ավելացնել սև ցուցակում
                          </label>
                          </label>
                        </div>
                        <div v-if="participant.add_to_blacklist" class="form-group text-left my-2">
                          <label :for="`blacklist-duration-${participant.id}`">Ժամկետ</label>
                          <select v-model.number="participant.blacklist_duration_months" class="form-control br-8" :id="`blacklist-duration-${participant.id}`">
                            <option :value="3">3 ամիս</option>
                            <option :value="6">6 ամիս</option>
                            <option :value="12">1 տարի</option>
                          </select>
                        </div>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </template>
        </div>
      </div>
    </div>
    <div id="modal-footer">
      <button
        v-can="'tender.update'"
        v-if="!currentOrganized.auction && currentOrganized.type == 2" :disabled="isLoading" @click="openMakeAuction" class="btn btn-primary br-8 mr-3">
        <span>Կազմակերպել աճուրդ</span>
      </button>
      <button
        v-can="'tender.update'"
        v-if="currentOrganized.type == 4" :disabled="isLoading || participants.length === 0" @click="openMakePriceReduction" class="btn btn-primary br-8 mr-3">
        <span>Կազմակերպել սակարկություն</span>
      </button>
      <button
        v-can="'tender.update'"
        class="btn btn-primary br-8"
        :disabled="isLoading || participants.length === 0"
        @click="save"
      >
        <span v-if="isLoading" class="mr-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span>Պահպանել</span>
      </button>
    </div>
    <commercial-terms-modal />
    <participant-row-activity-log-modal />
    <configure-price-reduction-modal />
  </modal>
</template>

<script>
import moment from 'moment'
import isMobile from '@/mixins/isMobileView'
import RowTemplate from '@/components/tenders/row'
import price from "@/mixins/price";
import brand from "@/mixins/brand";
import CommercialTermsModal from "./CommercialTermsModal";
import ParticipantRowActivityLogModal from "./ParticipantRowActivityLogModal";
import ConfigurePriceReductionModal from "./ConfigurePriceReductionModal";

export default {
    name: 'WinnerEvalutionModal',
    mixins: [isMobile, price, brand],
    components: { CommercialTermsModal, ParticipantRowActivityLogModal, ConfigurePriceReductionModal },
    templates: {
			RowTemplate
		},
    data() {
      return {
        columns: [
          'index_number',
          'name',
          'lots',
          'cost',
          'specification',
          'action',
        ],
        options: {
          childRow: RowTemplate,
          sortable: [],
          perPage: 1000,
          perPageValues: [],
          columnsDropdown: false,
          filterByColumn: false,
          skin: 'table table-striped table-border-radius',
          dateFormat: "YYYY-mm-dd",
          headings: {
            index_number: 'Հ/Հ',
            name: 'Անվանում',
            lots: 'Գնման առարկա',
            cost: 'Ներկայացված գին',
            specification: 'Ներկայացված տեխնիկական բնութագիր',
            action: this.organizeType !== 3 ? 'Գնահատում' : 'Հաղթող',
          },
          filterable: false
        },
        isLoading: false,
        participantGroup: {},
        winnerByLots: false,
        is_satisfactory: 1,
        participants: [],
        organizeType: 1,
        winnerId: 0,
        winnerRows: {},
        viewMode: 'participant',
        isExporting: false,
      }
    },
    computed: {
      me() {
        return this.$store.getters['user/me']
      },
      currentOrganized() {
        return this.$store.getters['organizeItender/currentOrganized']
      },
      organizedRowsList() {
        return this.$store.getters['organizeItender/organizedRows']
      },
      hasBlacklistEnabled() {
        return Boolean(this.me?.organisation?.[0]?.has_blacklist)
      },
      lotsGrouped() {
        const map = {}
        const order = []
        this.participants.forEach((participant) => {
          participant.lots.forEach((lot) => {
            const rowId = lot.organize_row_id
            if (!map[rowId]) {
              map[rowId] = {
                organize_row_id: rowId,
                view_id: lot.row ? lot.row.view_id : '',
                cpv: lot.cpv,
                items: [],
              }
              order.push(rowId)
            }
            map[rowId].items.push({ participant, lot })
          })
        })
        return order.map((id) => map[id])
      },
    },
    methods: {
      formatVerificationDate(value) {
        return value ? moment(value).format('DD.MM.YYYY, HH:mm') : '';
      },
      openCommercialTermsModal(participant) {
        this.$modal.show('participant-commercial-terms-modal', { participant });
      },
      getParticipantOfferExcel(participant) {
        if (!participant) {
          return null;
        }

        return participant.cpv_offer_excel
      },
      openActivityLogModal(lot) {
        this.$modal.show('participant-activity-log-modal', {
          lotId: lot.id,
          lotLabel: lot.cpv ? `- ${lot.cpv.name}` : '',
        });
      },
      toggleWinner(winnerId, orgRowId = null) {
        if (this.winnerByLots) {
          this.winnerRows[orgRowId] = this.winnerRows[orgRowId] === winnerId ? null : winnerId
          if (this.winnerRows[orgRowId] === null) {
            document.getElementById(`winner-${orgRowId}-${winnerId}`).checked = false
          }
        } else {
          this.winnerId = winnerId === this.winnerId ? null : winnerId
          if (this.winnerId === null) {
            document.getElementById(`winner-${winnerId}`).checked = false
          }
        }
      },
      openMakeAuction() {
        this.$modal.show('configure-auction-modal')
      },
      async exportEvaluationExcel() {
        this.isExporting = true
        try {
          const { data } = await this.$client.get(`organize/itender/${this.currentOrganized.id}/evaluation/export`, {
            params: { mode: this.viewMode },
            responseType: 'blob',
          })
          const url = window.URL.createObjectURL(new Blob([data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `gnahatum-${this.currentOrganized.id}.xlsx`)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        } catch (e) {
          // ignore, no export
        } finally {
          this.isExporting = false
        }
      },
      openMakePriceReduction() {
        this.$modal.show('configure-price-reduction-modal', {
          participants: this.participants
        })
      },
      averageOfTwo(a, b) {
        if (a === null || a === undefined || b === null || b === undefined) return '-'
        return Math.round(((a + b) / 2) * 10) / 10
      },
      consoleLog(msg) {
        console.log(msg)
      },
      handleBeforeOpen({params}) {
        this.organizeType = this.organizedRowsList[0].type
        this.organizedRowsList.forEach((row) => {
          const rowId = row.id;
          this.winnerRows[rowId] = row.winner?.id;
        })
        if(this.currentOrganized.winners.length){
          this.winnerId = this.currentOrganized.winners[0].id;
        }

        this.participants = JSON.parse(JSON.stringify(this.currentOrganized.participants));
        if (this.participants.length) {
          // json stringify/parse is done for avoid errors (VUEX)
          this.participants.forEach((participant) => {
            participant.lots.forEach((lot) => {
              lot.cpv = lot.row.procurement_plan.is_from_outside ?
                lot.row.procurement_plan.cpv_outside : lot.row.procurement_plan.cpv
            })
            this.$set(participant, 'add_to_blacklist', false)
            this.$set(participant, 'blacklist_duration_months', 3)
          })
        }

        this.winnerByLots = this.currentOrganized.winner_by_lots
      },
      submitBlacklistEntries() {
        const toBlacklist = this.participants.filter((participant) => participant.add_to_blacklist && participant.tin)
        return Promise.all(toBlacklist.map((participant) => {
          return this.$client.post('organisation/blacklist', {
            tin: participant.tin,
            duration_months: participant.blacklist_duration_months,
          })
        }))
      },
      save() {
        if(this.hasBlacklistEnabled){
          this.submitBlacklistEntries()
        }
        if(this.organizeType === 1 || this.organizeType === 2 || this.organizeType === 4){
          this.$client.post(`organize/itender/evalution/${this.currentOrganized.id}`, this.participants).then(({data: {data}}) => {
            if(data) {
              this.$store.commit('organizeItender/setCurrentOrganized', data)
              this.$modal.hide('winner-evalution-modal')
            }
          })
        } else if(this.organizeType === 3){
          let requestData = {winner: this.winnerId}
          if(this.currentOrganized.winner_by_lots){
            requestData = {winnerRows: this.winnerRows}
          }
          this.$client.post(`organize/itender/setWinner/${this.currentOrganized.id}`, requestData).then(({data: {data}}) => {
            if(data) {
              this.$store.commit('organizeItender/setCurrentOrganized', data)
              this.$modal.hide('winner-evalution-modal')
            }
          })
        }
      }
    },
  }
</script>

<style scoped>
  input[type=radio] {
    width: 20px;
    transform: scale(1.5);
  }
  tr{
    background: transparent !important;
  }
</style>
